import { render } from "./InfoView.vue?vue&type=template&id=0b6fb651"
const script = {}

import exportComponent from "../../.yarn/__virtual__/vue-loader-virtual-5e85c868fe/2/.yarn/berry/cache/vue-loader-npm-17.4.2-00674d01e5-10c0.zip/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__